import { useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/rules', label: '赛事规则' },
    { to: '/category/guide', label: '参赛指南' },
    { to: '/category/prizes', label: '奖品详情' },
    { to: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 no-underline"
          >
            <span className={`font-heading text-xl font-bold whitespace-nowrap ${
              isHome && !scrolled ? 'text-white' : 'text-primary-600'
            }`}>
              {siteConfig.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  isActive(link.to)
                    ? isHome && !scrolled
                      ? 'bg-white/20 text-white'
                      : 'bg-primary-100 text-primary-700'
                    : isHome && !scrolled
                      ? 'text-white/80 hover:text-white hover:bg-white/10'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="/category/guide"
              className={`px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-200 cursor-pointer ${
                isHome && !scrolled
                  ? 'bg-white text-primary-600 hover:bg-white/90'
                  : 'bg-primary-500 text-white hover:bg-primary-600'
              }`}
            >
              立即参赛
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              isHome && !scrolled ? 'text-white' : 'text-foreground-700'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-3 px-4">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMobileOpen(false)}
                  className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive(link.to)
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="/category/guide"
                onClick={() => setMobileOpen(false)}
                className="mt-2 px-5 py-3 rounded-lg text-sm font-semibold text-center bg-primary-500 text-white whitespace-nowrap cursor-pointer"
              >
                立即参赛
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}